/* eslint-disable camelcase */
export function spBeginCheckout({ method, items }) {
    if (!method || !Array.isArray(items)) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'sp_begin_checkout',
        method,
        ecommerce: {
            items: items.map(({ ProductClassName, ItemNumber, ProductId, Brand, ParentReportingCategory, ChildReportingCategory, IsAutoShip, IsSmartPak, Price, Quantity }) => {
                return {
                    item_name: ProductClassName,
                    item_id: ItemNumber,
                    item_variant: ProductId,
                    item_brand: Brand,
                    item_parent_reporting_category: ParentReportingCategory,
                    item_child_reporting_category: ChildReportingCategory,
                    item_autoship: typeof IsAutoShip === 'boolean' && IsAutoShip ? 'yes' : 'no',
                    item_smartpak: typeof IsSmartPak === 'boolean' && IsSmartPak ? 'yes' : 'no',
                    price: Price,
                    quantity: Quantity
                };
            })
        }
    });
}